import { setPageHeadingAction } from "@src/layout/store/actions";
import { useRouter } from "@src/lib/router";
import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { t } from "i18next";
import PhysicalAddress from "@src/components/PhysicalAddress";

const CoursePhysicalAddress = () => {
  // NEXTJS ROUTER
  const router = useRouter();

  // REDUX DISPATCH
  const dispatch = useDispatch();

  // SELECTORS
  const isEditMode = useSelector(
    (state) => state?.physicalShipmentReducer?.isEditMode
  );
  const isPhysicalDeliveryEnabled = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isPhysicalDeliveryEnabled
  );
  // SETTTING PAGE TITLE ON PAGE MOUNT
  React.useEffect(() => {
    dispatch(
      setPageHeadingAction(
        isEditMode
          ? t(
            "pages.courseId.physicaladdress.index.updateAddress",
            "Update Address"
          )
          : t(
            "pages.courseId.physicaladdress.index.addNewAddress",
            "Add New Address"
          )
      )
    );
    return () => {
      dispatch(setPageHeadingAction());
    };
  }, []);

  return <PhysicalAddress isPhysicalDeliveryEnabled={isPhysicalDeliveryEnabled===2} />;
};

// DEFINING LAYOUT PROPERTIES FOR THIS PAGE
CoursePhysicalAddress.getLayoutProps = () => ({
  accent: true,
  noFooter: true,
  blockHeader: true,
  noPullToRefresh: true,
});

export default CoursePhysicalAddress;
